import clsx from 'clsx';
import React, { memo } from 'react';

import IconBookmark from '@components/Images/IconBookmark';

import { BookmarkSize } from './constants';

interface BookmarkButtonProps {
  isBookmarked: boolean;
  isDisabled: boolean;
  onClick: () => void;
  size: BookmarkSize;
  tooltipMessage: string;
}

const BookmarkButton = ({
  isBookmarked,
  isDisabled,
  onClick,
  size,
  tooltipMessage,
}: BookmarkButtonProps) => (
  <button
    className="group m-0 flex cursor-pointer items-center justify-center border-none bg-transparent p-0"
    disabled={isDisabled}
    onClick={onClick}
    type="button"
    aria-disabled={isDisabled}
    aria-label={tooltipMessage}
  >
    <IconBookmark
      className={clsx(
        'transition-all duration-150 ease-in-out sm:group-hover:fill-primary-magenta sm:group-hover:text-primary-magenta',
        {
          'fill-primary-magenta text-primary-magenta sm:group-hover:!fill-primary-pink sm:group-hover:text-primary-pink':
            isBookmarked,
          'text-grayscale-gray dark:text-white': !isBookmarked,
          '!fill-grayscale-gray !text-grayscale-gray opacity-50 dark:!fill-white dark:!text-white':
            isDisabled,
          'stroke-[3px]': size === BookmarkSize.Small,
        }
      )}
      height={size}
    />
  </button>
);

export default memo(BookmarkButton);
